import React from 'react'
import styled from 'styled-components'
import { mobile } from '../utils/media-query'

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 1px solid black;
    box-sizing: border-box;
    color: black;
    font-weight: bold;
    font-family: 'PT Mono', monospace;
    padding: 8px 25px;
    font-size: 16px;

    ${mobile.css`
        font-size: 15px;
    `}
`

type TransparentTextButtonProps = {
    text: string
}
const TransparentTextButton = ({ text }: TransparentTextButtonProps) => <Container>{text}</Container>

export default TransparentTextButton
